import { PARTNER_TYPES } from './partnerTypes';

export const WHOLESALE_TYPES = {
  FULL_SERVICE_WHOLESALE: PARTNER_TYPES.FULL_SERVICE_WHOLESALE,
  WHITE_LABEL_WHOLESALE: PARTNER_TYPES.WHITE_LABEL_WHOLESALE,
};

export const WHOLESALE_TYPES_LIST = Object.values(WHOLESALE_TYPES);
